import { ColorOptions, TextNew } from '@jfs/ui-new'
import React from 'react'
import { styles } from './index'

export const VpaStatus = ({ title }: any) => {
  const colors: any = {
    'Fetched from MAS': 'YELLOW' as ColorOptions,
    'Added in MMS': 'GREEN' as ColorOptions,
    'Added in MMS (Disabled)': 'GREEN' as ColorOptions,
    'Deleted from MAS': 'RED' as ColorOptions,
  }
  return <TextNew {...styles.labelStyle} color={colors[title]} fontFamily={'jiotype-medium'} title={title} />
}
